import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Plus, Trash2, MapPin } from "lucide-react";

const empty = { label: "Home", line1: "", city: "", state: "", pincode: "", phone: "" };

export default function AccountAddresses() {
  const [addresses, setAddresses] = useState([]);
  const [adding, setAdding] = useState(false);
  const [form, setForm] = useState(empty);

  const load = () => api.get("/account/addresses").then((r) => setAddresses(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/account/addresses", form);
      toast.success("Address saved");
      setForm(empty); setAdding(false); load();
    } catch { toast.error("Could not save"); }
  };

  const del = async (id) => {
    if (!window.confirm("Delete this address?")) return;
    await api.delete(`/account/addresses/${id}`);
    toast.success("Deleted"); load();
  };

  return (
    <div data-testid="account-addresses">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <h2 className="font-display text-2xl uppercase tracking-tight">Saved Addresses</h2>
          <div className="divider-orange mt-3" />
        </div>
        {!adding && (
          <button data-testid="address-add" onClick={() => setAdding(true)} className="btn-orange py-2 px-4 text-xs">
            <Plus size={14} /> Add Address
          </button>
        )}
      </div>

      {adding && (
        <form onSubmit={submit} className="mt-6 border border-white/10 p-6 space-y-3" data-testid="address-form">
          <div className="grid sm:grid-cols-2 gap-3">
            <input data-testid="addr-label" required value={form.label} onChange={(e) => setForm({ ...form, label: e.target.value })} placeholder="Label (Home, Work...)" className="bg-[#111] border border-white/15 px-3 py-2.5 focus:outline-none focus:border-[#D96A1B]" />
            <input data-testid="addr-phone" required value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="Phone" className="bg-[#111] border border-white/15 px-3 py-2.5 focus:outline-none focus:border-[#D96A1B]" />
          </div>
          <input data-testid="addr-line1" required value={form.line1} onChange={(e) => setForm({ ...form, line1: e.target.value })} placeholder="Street address" className="w-full bg-[#111] border border-white/15 px-3 py-2.5 focus:outline-none focus:border-[#D96A1B]" />
          <div className="grid sm:grid-cols-3 gap-3">
            <input data-testid="addr-city" required value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} placeholder="City" className="bg-[#111] border border-white/15 px-3 py-2.5" />
            <input data-testid="addr-state" required value={form.state} onChange={(e) => setForm({ ...form, state: e.target.value })} placeholder="State" className="bg-[#111] border border-white/15 px-3 py-2.5" />
            <input data-testid="addr-pincode" required value={form.pincode} onChange={(e) => setForm({ ...form, pincode: e.target.value })} placeholder="Pincode" className="bg-[#111] border border-white/15 px-3 py-2.5" />
          </div>
          <div className="flex gap-2">
            <button data-testid="addr-save" className="btn-orange">Save Address</button>
            <button type="button" onClick={() => { setAdding(false); setForm(empty); }} className="btn-ghost">Cancel</button>
          </div>
        </form>
      )}

      <div className="mt-6 grid md:grid-cols-2 gap-4">
        {addresses.length === 0 && !adding ? (
          <div className="md:col-span-2 border border-white/10 py-16 text-center">
            <MapPin className="mx-auto text-white/30" size={32} />
            <p className="mt-3 text-white/55 font-body">No saved addresses yet.</p>
          </div>
        ) : addresses.map((a) => (
          <div key={a.id} data-testid={`address-${a.id}`} className="border border-white/10 p-5 relative">
            <div className="overline mb-1">{a.label}</div>
            <div className="font-body text-sm text-white/80 leading-relaxed">
              {a.line1}<br />{a.city}, {a.state} – {a.pincode}<br />📞 {a.phone}
            </div>
            <button data-testid={`addr-delete-${a.id}`} onClick={() => del(a.id)} className="absolute top-3 right-3 text-white/40 hover:text-[#D96A1B]"><Trash2 size={14} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
